import React, { useRef, useState } from "react";

/**
 * Before / After image comparison slider. Drag or click to reveal.
 */
export default function BeforeAfterSlider({ before, after, label = "Before & After" }) {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const [dragging, setDragging] = useState(false);

  const updatePos = (clientX) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setPos(pct);
  };

  const onMouseDown = () => setDragging(true);
  const onMouseUp = () => setDragging(false);
  const onMouseMove = (e) => {
    if (!dragging) return;
    updatePos(e.clientX);
  };
  const onTouchStart = () => setDragging(true);
  const onTouchMove = (e) => {
    if (!dragging) return;
    updatePos(e.touches[0].clientX);
  };

  return (
    <div
      ref={containerRef}
      className="relative w-full aspect-[4/3] sm:aspect-video rounded-2xl overflow-hidden select-none cursor-ew-resize bg-black"
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseUp}
      onTouchMove={onTouchMove}
      onTouchEnd={onMouseUp}
      data-testid="before-after-slider"
    >
      {/* After (full) */}
      <img
        src={after}
        alt={`${label} - after`}
        className="absolute inset-0 w-full h-full object-cover"
        draggable={false}
      />
      {/* Before (clipped) */}
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      >
        <img
          src={before}
          alt={`${label} - before`}
          className="w-full h-full object-cover"
          draggable={false}
        />
      </div>

      {/* Labels */}
      <span className="absolute top-3 left-3 bg-black/60 text-white text-[10px] tracking-[0.25em] uppercase font-bold px-2.5 py-1.5 rounded-full backdrop-blur">
        Before
      </span>
      <span className="absolute top-3 right-3 bg-[#7CB342] text-[#0A0E17] text-[10px] tracking-[0.25em] uppercase font-bold px-2.5 py-1.5 rounded-full">
        After
      </span>

      {/* Handle */}
      <div
        className="absolute top-0 bottom-0 w-0.5 bg-white/90 pointer-events-none"
        style={{ left: `${pos}%` }}
      />
      <div
        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-[#2EA9E0] shadow-[0_8px_24px_rgba(46,169,224,0.45)] flex items-center justify-center"
        style={{ left: `${pos}%` }}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/><polyline points="9 18 15 12 9 6" transform="translate(-2 0)"/></svg>
      </div>
    </div>
  );
}
